import React, { useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { FaSearch } from 'react-icons/fa';
import instanciaAxios from '../../../miscelaneo/instanciaAxios';
import SpinnerCargando from '../SpinnerCargando';

function TablaRetencion({ setRetencionSeleccionada = () => {}, descripcion }) {
  const [filtro, setFiltro]     = useState('');
  const [retenciones, setRetenciones]     = useState([]);
  const [cargando, setCargando] = useState(true);

  const handleRowClick = (retencion) => {
    const retencionSeleccionada = [retencion.id_retencion, retencion.descripcion,retencion.porcentaje,retencion.id_tipo_retencion];
    setRetencionSeleccionada(retencionSeleccionada);
  };

  useEffect(() => {
    (async () => {
      try {
        setCargando(true);
        const res = await instanciaAxios.get('/miscelaneo/retencion');
        setRetenciones(res.status === 200 ? res.data : []);
                console.log(res.data)

      } catch {
        setRetenciones([]);
      } finally {
        setCargando(false);
      }
    })();
  }, []);

  const datosFiltrados = useMemo(() => {
    if (!filtro) return retenciones;
    return retenciones.filter(ret =>
      (ret.descripcion || '').toLowerCase().includes(filtro.toLowerCase())
    );
  }, [filtro, retenciones]);

  const columns = [
    {
      name: 'Descripción',
      selector: row => row.descripcion,
      sortable: true
    },
{
      name: 'Tipo',
      selector: row => row.id_tipo_retencion == '1' ? 'ISR' : 'ITBIS',
      sortable: true
    },
    {
      name: 'Porcentaje',
      selector: row => `${(row.porcentaje*100)}%`,
      sortable: true
    }
  ];

  if (cargando) return <SpinnerCargando />;

  return (
    <DataTable
      keyField="id_retencion"
      title={
        <>
          <h2 className="text-xl font-semibold text-center">Retenciones</h2>
          {descripcion && (
            <p className="text-sm text-gray-500 text-center">{descripcion}</p>
          )}
        </>
      }
      columns={columns}
      data={datosFiltrados}
      pagination
      dense
      highlightOnHover
      onRowClicked={handleRowClick}
      noDataComponent={
        <div className="text-gray-500">No se encontraron retenciones.</div>
      }
      subHeader
      subHeaderComponent={
        <div className="w-full relative">
          <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-color-secundario" />
          <input
            type="text"
            placeholder="Buscar retencion..."
            className="w-full border px-3 py-1 rounded-xl"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />
        </div>
      }
    />
  );
}

export default TablaRetencion;
